/** Fields a calculation-node listing can be sorted by. */
export const SortFieldValues = [
    // Numeric derived fields (_last)
    'price_index_last',
    'price_index_10k_last',
    'price_index_50k_last',
    'stock_index_last',
    'lead_time_index_last',
    'purchase_price_index_last',
    'contract_price_index_last',
    'quote_price_index_last',
    'number_of_offers_last',
    'pct_missing_offers_last',
    'demand_quantity_last',
    'savings_last',
    'current_spend_baseline_last',
    // Numeric derived fields (_pct_change)
    'price_index_pct_change',
    'price_index_10k_pct_change',
    'price_index_50k_pct_change',
    'stock_index_pct_change',
    'lead_time_index_pct_change',
    'purchase_price_index_pct_change',
    'contract_price_index_pct_change',
    'quote_price_index_pct_change',
    'number_of_offers_pct_change',
    'pct_missing_offers_pct_change',
    'demand_quantity_pct_change',
    'savings_pct_change',
    'current_spend_baseline_pct_change',
    // Numeric derived fields (_absolute_change)
    'price_index_absolute_change',
    'price_index_10k_absolute_change',
    'price_index_50k_absolute_change',
    'stock_index_absolute_change',
    'lead_time_index_absolute_change',
    'purchase_price_index_absolute_change',
    'contract_price_index_absolute_change',
    'quote_price_index_absolute_change',
    'number_of_offers_absolute_change',
    'pct_missing_offers_absolute_change',
    'demand_quantity_absolute_change',
    'savings_absolute_change',
    'current_spend_baseline_absolute_change',
    // Text fields
    'name',
    'mpn',
    'manufacturer_name',
    'description',
    'category',
    // OffTheShelfPart specific fields
    'lifecycle_status',
    'lifecycle_yteol',
    'country_of_origin',
    'hts_code',
    'package',
    'aecq_compliant',
    'china_rohs_compliant',
    'reach_compliant',
    'pfas_compliant',
    'prop65_compliant',
] as const;

export type SortField = (typeof SortFieldValues)[number];
